module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('sui-header'), _vm._v(" "), _c('div', {
    staticClass: "hero is-dark"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('profile-header-hero', {
    attrs: {
      "person": _vm.person
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "is-hidden-tablet"
  }, [_c('profile-header-mobile', {
    attrs: {
      "person": _vm.person
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-one-quarter"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n              Explore " + _vm._s(_vm.person.name) + "\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/items',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })]), _vm._v("\n                  Items -\n                  " + _vm._s(_vm.person.stats.item) + "\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/collections',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v("\n                  Collections -\n                  " + _vm._s(_vm.person.stats.collection) + "\n                ")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n              People\n            ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/following',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v("\n                  Following -\n                  " + _vm._s(_vm.person.stats.followee) + "\n                ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'profile/followers',
        params: {
          profileId: _vm.profileId
        }
      },
      "active-class": "is-active"
    }
  }, [_c('span', {
    staticClass: "panel-icon"
  }, [_c('i', {
    staticClass: "fa fa-users"
  })]), _vm._v("\n                  Followers -\n                  " + _vm._s(_vm.person.stats.follower) + "\n                ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('router-view', {
    attrs: {
      "person": _vm.person
    }
  })], 1)])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0c71ad78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileLayout--HeroSidebar.vue
// module id = 275
// module chunks = 1